import React from 'react';
import RModal from '../Rsuite/Modal';
import { useAlert } from '../../contexts/Alert.context';
import { CustomButton } from '../CustomButton';
import { Text } from '../Text/Text';

export const Alert = () => {
  const { openAlert, title, text, submitText, onSubmit, closeAlert } =
    useAlert();
  return (
    <RModal
      open={openAlert}
      onClose={closeAlert}
      title={title}
      footer={
        <div>
          <CustomButton appearance="default" onClick={closeAlert}>
            Cancelar
          </CustomButton>
          <CustomButton onClick={onSubmit}>
            {submitText || 'Confirmar'}
          </CustomButton>
        </div>
      }
    >
      <Text>{text}</Text>
    </RModal>
  );
};
